module.exports = __webpack_public_path__ + "static/UnclickInSingapore-e8ccf49d6bd929280f7bc06d6a9d337f.png";